import { App_Url_New } from "@/src_new/shared/common/static";

import type { ResumeTarget } from "../utils/resumeJourney";

const carGetQuoteStep = (stepIndex: number) =>
  `${App_Url_New.frontLinks.insurance.carGetQuote}?step=${stepIndex}`;

export const MOTOR_RESUME_STEP_TARGETS = {
  step_1_pre_request: {
    path: carGetQuoteStep(1),
    stepIndex: 1,
    stepLabel: "Personal Details",
  },
  step_2_pre_request: {
    path: carGetQuoteStep(2),
    stepIndex: 2,
    stepLabel: "Vehicle Details",
  },
  step_3_pre_request: {
    path: carGetQuoteStep(3),
    stepIndex: 3,
    stepLabel: "Driver Details",
  },
  quote_request: {
    path: carGetQuoteStep(4),
    stepIndex: 4,
    stepLabel: "Get Quote",
  },
  selected_quote: {
    path: carGetQuoteStep(4),
    stepIndex: 4,
    stepLabel: "Buy Now",
  },
  step_5_post_request: {
    path: carGetQuoteStep(5),
    stepIndex: 5,
    stepLabel: "Document Upload",
  },
  step_6_post_request: {
    path: carGetQuoteStep(6),
    stepIndex: 6,
    stepLabel: "Additional Details",
  },
  step_7_post_request: {
    path: carGetQuoteStep(7),
    stepIndex: 7,
    stepLabel: "Payment",
  },
  step_8_post_request: {
    path: App_Url_New.frontLinks.insurance.carPolicyResult,
    stepLabel: "Policy Issue",
  },
} satisfies Record<string, ResumeTarget>;

export const MOTOR_RESUME_STEP_FALLBACK_ORDER = [
  "step_8_post_request",
  "step_7_post_request",
  "step_6_post_request",
  "step_5_post_request",
  "selected_quote",
  "quote_request",
  "step_3_pre_request",
  "step_2_pre_request",
  "step_1_pre_request",
] as const;

export type MotorResumeStepName = keyof typeof MOTOR_RESUME_STEP_TARGETS;
